import { useQuery } from "@tanstack/react-query";

import { Card, CardBody, CardHeader, CardTitle } from "@/components/ui/Card";
import { PageTitleWithHelp } from "@/components/ui/title-help";
import { getCommissionRules } from "./commissionsApi";

export function CommissionRulesPage() {
  const rulesQuery = useQuery({
    queryKey: ["commissions", "rules"],
    queryFn: getCommissionRules,
  });

  return (
    <div className="space-y-6">
      <PageTitleWithHelp hoverHint="Authoritative commission business rules served from the calculation engine. Change constants in source — this page updates with them.">
        Commission rules
      </PageTitleWithHelp>

      <p className="text-sm text-slate-600">
        Engine {rulesQuery.data?.engineVersion ?? "…"}. These texts are built from the same constants the
        monthly compute uses — do not treat spreadsheets or copied notes as more current than this page.
      </p>

      {(rulesQuery.data?.rules ?? []).map((rule) => (
        <Card key={rule.id}>
          <CardHeader>
            <CardTitle>{rule.title}</CardTitle>
          </CardHeader>
          <CardBody className="space-y-2 text-sm text-slate-700 whitespace-pre-wrap">
            <p className="font-medium text-slate-900">{rule.summary}</p>
            <p>{rule.detail}</p>
            {rule.example != null && rule.example !== "" ? (
              <p>
                <span className="font-medium text-slate-900">Example: </span>
                {rule.example}
              </p>
            ) : null}
            {rule.manualOverride != null ? <p className="text-slate-600">{rule.manualOverride}</p> : null}
            {rule.dates != null ? (
              <ul className="list-disc pl-5 text-slate-600">
                {Object.entries(rule.dates).map(([key, value]) => (
                  <li key={key}>
                    <span className="font-medium text-slate-800">{key}: </span>
                    {value}
                  </li>
                ))}
              </ul>
            ) : null}
            <p className="text-xs text-slate-500">
              id {rule.id} · {rule.sourceModule}
              {rule.gapYears != null ? ` · gap ${rule.gapYears}` : ""}
              {rule.windowYears != null ? ` · window ${rule.windowYears}` : ""}
              {rule.owingLagMonths != null ? ` · review opens ${rule.owingLagMonths} month(s) after payment month` : ""}
              {rule.tierUnitsMaxLow != null
                ? ` · tiers ${rule.tierUnitsMaxLow}/${rule.tierUnitsMaxMid}`
                : ""}
            </p>
          </CardBody>
        </Card>
      ))}
    </div>
  );
}
